import { useSearchParams } from 'react-router-dom';

import { ACCOUNT_OFFER_PARAM } from './accountRelatedModel';

export function useAccountOfferId() {
  const [searchParams] = useSearchParams();
  return searchParams.get(ACCOUNT_OFFER_PARAM) ?? undefined;
}
